import React, { MouseEventHandler, useCallback } from 'react';

import { Box, Button, Typography } from '@mui/material';

import { TBlockButton } from '../blocks/helpers/defineBlockButton';

type BlockMenuButtonProps = {
  button: TBlockButton;
  onClick: (button: TBlockButton) => void;
};

export default function BlockTypeButton({ button, onClick }: BlockMenuButtonProps) {
  const onClickHandler = useCallback<MouseEventHandler<HTMLElement>>(
    (ev) => {
      ev.stopPropagation();
      onClick(button);
    },
    [button, onClick]
  );
  return (
    <Button onClick={onClickHandler} sx={{ p: 1.5, display: 'flex', flexDirection: 'column' }}>
      <Box
        sx={{
          mb: 0.75,
          width: '100%',
          bgcolor: 'cadet.200',
          display: 'flex',
          justifyContent: 'center',
          p: 1,
          border: '1px solid',
          borderColor: 'cadet.300',
        }}
      >
        {button.icon}
      </Box>
      <Typography variant="body2">{button.label}</Typography>
    </Button>
  );
}
